import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { GraduationCap, Menu, X, ArrowRight } from "lucide-react";
import ThemeSwitcher from "./ThemeSwitcher";

export default function GlobalAppHeader() {
  const [ccy, setCcy] = useState(localStorage.getItem("ponderr_ccy") || "INR");
  const [open, setOpen] = useState(false);
  const [cfg, setCfg] = useState({ enable_store_landing: true, enable_tv_landing: true });

  useEffect(() => { api.get("/site-settings").then(r => setCfg(r.data)).catch(() => {}); }, []);
  const toggleCcy = () => {
    const n = ccy === "INR" ? "USD" : "INR";
    setCcy(n); localStorage.setItem("ponderr_ccy", n); window.dispatchEvent(new Event("ponderr-ccy"));
  };
  const storeHref = cfg.enable_store_landing ? "/store" : "/#storez";
  const tvHref = cfg.enable_tv_landing ? "/tv" : "/#ponderr-tv";

  const NavLinks = ({ onClick }) => (
    <>
      <Link to={storeHref} onClick={onClick} className="pf-btn !bg-transparent !shadow-none text-sm" data-testid="nav-store">Storez</Link>
      <Link to={tvHref} onClick={onClick} className="pf-btn !bg-transparent !shadow-none text-sm" data-testid="nav-tv">Ponderr TV</Link>
      <a href="/#schools" onClick={onClick} className="pf-btn !bg-transparent !shadow-none text-sm">Schools</a>
      <Link to="/posts" onClick={onClick} className="pf-btn !bg-transparent !shadow-none text-sm" data-testid="nav-posts">News &amp; Updates</Link>
      <a href="/#plans" onClick={onClick} className="pf-btn !bg-transparent !shadow-none text-sm">Plans</a>
      <a href="/#onboarding" onClick={onClick} className="pf-btn !bg-transparent !shadow-none text-sm">Join</a>
    </>
  );

  return (
    <nav className="pf-surface border-b-2 pf-border sticky top-0 z-40 w-full max-w-full overflow-visible" data-testid="global-app-header">
      <div className="max-w-7xl mx-auto px-3 sm:px-6 py-3 flex items-center justify-between gap-2">
        <Link to="/" className="flex items-center gap-2 min-w-0" data-testid="global-brand">
          <div className="w-9 h-9 shrink-0 pf-primary-bg border-2 pf-border rounded-lg grid place-items-center shadow-[3px_3px_0_0_var(--pf-border)]">
            <GraduationCap size={20} strokeWidth={2.5} />
          </div>
          <span className="display text-xl sm:text-2xl font-bold truncate">Ponderr</span>
        </Link>

        {/* Desktop nav */}
        <div className="hidden md:flex items-center gap-2">
          <NavLinks />
          <button onClick={toggleCcy} className="pf-btn !bg-transparent !shadow-none text-sm" data-testid="ccy-toggle">{ccy === "INR" ? "₹ INR" : "$ USD"}</button>
          <ThemeSwitcher />
          <Link to="/login" className="pf-btn text-sm" data-testid="global-signin">Sign In <ArrowRight size={14} /></Link>
        </div>

        {/* Mobile controls */}
        <div className="flex md:hidden items-center gap-2">
          <ThemeSwitcher compact />
          <button onClick={() => setOpen(v => !v)} data-testid="mobile-hamburger"
            className="pf-btn !px-2" aria-label="Menu">{open ? <X size={18} /> : <Menu size={18} />}</button>
        </div>
      </div>

      {/* Mobile drawer */}
      {open && (
        <div className="md:hidden border-t-2 pf-border pf-surface px-4 py-3 flex flex-col gap-2" data-testid="mobile-drawer">
          <NavLinks onClick={() => setOpen(false)} />
          <button onClick={toggleCcy} className="pf-btn !bg-transparent !shadow-none text-sm text-left">{ccy === "INR" ? "₹ INR" : "$ USD"}</button>
          <Link to="/login" className="pf-btn text-sm justify-center" onClick={() => setOpen(false)}>Sign In <ArrowRight size={14} /></Link>
        </div>
      )}
    </nav>
  );
}
